function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "141",
  height: "23",
  viewBox: "0 0 422.32 68.84"
}, props), /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 1 copy 2",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M107.68.09h8.4v68.74h-8.4zM124.47 30.27h24.11v8.4h-24.11zM156.97.09h8.4v68.74h-8.4zM351.93 68.84h8.4V.09h-8.4v68.75zM380 .09h-11.27v8.17H380a15.29 15.29 0 010 30.57h-11.27V47H380a23.45 23.45 0 100-46.91M216.37.09a34.37 34.37 0 1034.37 34.37A34.41 34.41 0 00216.37.09m0 60.63a26.26 26.26 0 1126.26-26.26 26.28 26.28 0 01-26.26 26.26M299.85.09a34.37 34.37 0 1034.37 34.37A34.4 34.4 0 00299.85.09m0 60.63a26.26 26.26 0 1126.26-26.26 26.28 26.28 0 01-26.26 26.26M66.82 55.45l-8.93-29.39h-8.15l13.01 42.78h8.15L91.82.09h-8.15L66.82 55.45zM8.15.09H0l13.01 42.77h8.15L8.15.09zM41.83.09L20.92 68.84h8.14L49.99.09h-8.16z"
})))));